// extracted by mini-css-extract-plugin
export var divider = "_ig-0";
export var systemMessage = "_ig-1";
export var systemMessageWrapper = "_ig-2";